<script setup>
import {onMounted, ref} from "vue";
import FileService from "../../services/FileService.js";
import PDF from "pdf-vue3";
import {useI18n} from 'vue-i18n';
import {Capacitor} from "@capacitor/core";
import {Browser} from "@capacitor/browser";
import fileService from '../../services/FileService.js';

const {t} = useI18n()

const props = defineProps({
  file: Object,
  isNewOnboarding: {
    type: Boolean,
    default: false,
  },
});

const loadedFile = ref({});
function fetchFile(uuid) {
  FileService.getContent(uuid).then(response => {
    loadedFile.value = response;
  });
}

onMounted(() => {
  fetchFile(props.file.uuid);
});

async function downloadFile() {
  const url = loadedFile.value.download_url;

  if (Capacitor.isNativePlatform()) {
    await Browser.open({
      url: url,
      windowName: '_system'
    });
    return;
  }

  fileService.downloadFileByPlatform(loadedFile.value.content, loadedFile.value.name, loadedFile.value.extension);
}
</script>

<template>
  <div class="px-1 py-5">
    <div class="text-end px-3">
      <button @click="downloadFile" v-if="loadedFile.content && !isNewOnboarding" class="btn btn-primary">{{ t('fileView.download') }}</button>
    </div>
    <div class="py-3" v-if="loadedFile && loadedFile.extension === 'pdf'">
      <PDF :src="loadedFile.content"/>
    </div>
    <div class="py-3" v-if="file && ['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(loadedFile.extension)">
      <img :src="loadedFile.content" alt="file.name" class="img-fluid"/>
    </div>
  </div>
</template>

<style scoped>


</style>
